<template>
    <div class="roles">
        <div class="row">
            <section class="role-header" id="role-header">
                <div>
                    <h2>Gathering Roles</h2>
                </div>
            </section>
        </div>
        <div class="row">
            <section class="gatherer" id="gatherer">
                <div class="container">
                    <div class="left-role">
                        <section class="col-md-4">
                            <img src="@/assets/img/roles/hunter.png" alt="Hunter">
                        </section>
                        <section class="col-md-8">
                            <p>
                                <strong>Hunter</strong>
                            </p>
                            <blockquote>
                                The hunter leaves no part of an animal to waste. After field dressing the animal a hunter takes the carcass and refines it into bones, meat, fur, and hides.
                            </blockquote>
                        </section>
                    </div>
                    <div class="right-role">
                        <section class="col-md-4">
                            <img src="@/assets/img/roles/forester.png" alt="Forester">
                        </section>
                        <section class="col-md-8">
                            <p>
                                <strong>Forester</strong>
                            </p>
                            <blockquote>
                                A Forester is a lover of the woods and knows exactly what is useful and what is not. They gather fallen wood, useful foliage, and delectable mushrooms.
                            </blockquote>
                        </section>
                    </div>
                    <div class="left-role">
                        <section class="col-md-4">
                            <img src="@/assets/img/roles/prospector.png" alt="Prospector">
                        </section>
                        <section class="col-md-8">
                            <p>
                                <strong>Prospector</strong>
                            </p>
                            <blockquote>
                                The Prospector knows valuable minerals when they see them, they mine ore, gemstones, and other minerals from the ground to refine into usable materials in all kinds of crafts.
                            </blockquote>
                        </section>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'GatheringComponent',
        data() {
            return {
            
            }
        }, 
    }
</script> 